import React, { useState } from 'react';
import { Form, Input, Button, Typography, App, ConfigProvider } from 'antd';
import { Link, useNavigate } from 'react-router-dom';
import { colors, customStyles, darkTheme } from '../theme';
import LoginImage from '../assets/loginimage.png';
import { registerUser } from '../services/api';
import Footer from '../components/Footer';

const { Text } = Typography;

function Register() {
  const navigate = useNavigate();
  const { message } = App.useApp();
  const [loading, setLoading] = useState(false);

  const onFinish = async (values) => {
    setLoading(true);
    try {
      await registerUser(values.username, values.password);
      message.success('Account created. You can now sign in.');
      navigate('/login');
    } catch (error) {
      message.error(error.response?.data?.detail || 'Registration failed.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <ConfigProvider theme={darkTheme}>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          minHeight: '100vh',
          background: '#0F0B1E',
          overflow: 'hidden',
        }}
      >
        <div
          style={{
            display: 'flex',
            flex: 1,
            overflow: 'hidden',
            flexWrap: 'wrap',
          }}
        >
          <div
            style={{
              flex: '1 1 400px',
              order: 1,
              background: 'linear-gradient(135deg, rgba(246, 46, 151, 0.12) 0%, rgba(21, 60, 180, 0.12) 100%)',
              overflow: 'hidden',
              minHeight: '300px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <img
              src={LoginImage}
              alt=""
              style={{
                width: '100%',
                height: '100%',
                minHeight: '320px',
                objectFit: 'cover',
                maskImage: 'radial-gradient(circle at center, black 50%, transparent 85%)',
                WebkitMaskImage: 'radial-gradient(circle at center, black 50%, transparent 85%)',
              }}
            />
          </div>

          <div
            style={{
              flex: '1 1 400px',
              order: 2,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              padding: '40px',
              overflow: 'hidden',
            }}
          >
            <div
              style={{
                width: '100%',
                maxWidth: '420px',
                textAlign: 'center',
              }}
            >
              <div
                style={{
                  ...customStyles.brandGradientText,
                  marginBottom: '8px',
                  fontSize: 'clamp(26px, 5vw, 40px)',
                  lineHeight: 1.2,
                  fontWeight: 900,
                  textAlign: 'center',
                  textShadow: '0 0 10px rgba(255, 255, 255, 0.15), 0 0 20px rgba(255, 255, 255, 0.1)',
                  maxWidth: '100%',
                }}
              >
                Create account
              </div>
              <Text style={{ color: '#9B95A8', display: 'block', marginBottom: '32px' }}>
                Register as a new user
              </Text>
              <Form
                name="register"
                onFinish={onFinish}
                layout="vertical"
                requiredMark={false}
                style={{ textAlign: 'left' }}
              >
                <Form.Item
                  label="Username"
                  name="username"
                  rules={[{ required: true, message: 'Please enter a username' }]}
                >
                  <Input size="large" placeholder="Enter your username" autoComplete="username" />
                </Form.Item>
                <Form.Item
                  label="Password"
                  name="password"
                  rules={[{ required: true, message: 'Please enter a password' }]}
                >
                  <Input.Password size="large" placeholder="Enter your password" autoComplete="new-password" />
                </Form.Item>
                <Form.Item>
                  <Button type="primary" htmlType="submit" size="large" block loading={loading}>
                    Register
                  </Button>
                </Form.Item>
              </Form>
              <div style={{ textAlign: 'center', marginTop: '24px' }}>
                <Text style={{ color: '#9B95A8' }}>
                  Already have an account?{' '}
                  <Link to="/login" style={{ color: colors.persianRose }}>
                    Sign in
                  </Link>
                </Text>
              </div>
            </div>
          </div>
        </div>
        <Footer forcePublicDark />
      </div>
    </ConfigProvider>
  );
}

export default Register;
